// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RAIo5","content":"styles_content__1Yy8x"};